import { render, staticRenderFns } from "./_changePassword.vue?vue&type=template&id=3543f4b4&"
import script from "./_changePassword.vue?vue&type=script&lang=js&"
export * from "./_changePassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports